import { render } from "./SessionManager.vue?vue&type=template&id=00a23387&scoped=true"
import script from "./SessionManager.vue?vue&type=script&lang=js"
export * from "./SessionManager.vue?vue&type=script&lang=js"

import "./SessionManager.vue?vue&type=style&index=0&id=00a23387&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00a23387"]])

export default __exports__